import { Company, FetchCompaniesParams } from './types';
import { FailureActionPayload } from 'store/errors/types';
import { createAsyncAction, createAction } from 'typesafe-actions';

export interface FetchCompaniesSuccessPayload {
  companies: Company[];
  params: FetchCompaniesParams;
}

export const fetchCompanies = createAsyncAction(
  'companies/FETCH_REQUEST',
  'companies/FETCH_SUCCESS',
  'companies/FETCH_FAILURE',
)<FetchCompaniesParams, FetchCompaniesSuccessPayload, FailureActionPayload>();

export const resetCompanies = createAction('companies/RESET')();
